import * as TemplateTypes from 'types/template.types';

class MenuFadeTransition extends TemplateTypes.MenuTransition {
    constructor(config: TemplateTypes.BaseTransitionConfig){
        super(config, `
            .MenuFadeTransition-enter-active,
            .MenuFadeTransition-leave-active {
                transition: opacity ${config.duration ?? 500}ms ease;
            }
            
            .MenuFadeTransition-enter-from,
            .MenuFadeTransition-leave-to {
                opacity: 0;
            }
        `);
    }
}

export default MenuFadeTransition;